import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authStorage } from '../utils/auth';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';

function HomePage() {
  const navigate = useNavigate();
  const token = authStorage.getToken();
  const { config } = useConfig();

  useEffect(() => {
    if (token) navigate('/dashboard', { replace: true });
  }, [token, navigate]);

  if (token) return null;

  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      {/* Fondo con gradiente */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      {/* Imagen mujer con anatomía - centrada en mitad inferior, como fondo */}
      {mujerKvUrl && (
        <div className="absolute inset-0 z-0 flex items-end justify-center pointer-events-none overflow-hidden">
          <img
            src={mujerKvUrl}
            alt=""
            className="h-[55%] sm:h-[60%] w-auto max-w-[90vw] object-contain object-bottom mix-blend-screen brightness-110 opacity-50 sm:opacity-60"
          />
        </div>
      )}

      <div className="relative z-10 flex flex-col flex-1 min-h-0 px-4 pt-6 sm:pt-8">
        {/* Header: título del evento */}
        <div className="flex-shrink-0 w-full max-w-2xl mx-auto">
          <div className="relative overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[140px] sm:min-h-[200px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0">
                <img
                  src={config.headerImage}
                  alt="37 Simposio Internacional"
                  className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left"
                />
              </div>
            )}
          </div>
        </div>

        {/* Botones Registro / Iniciar sesión - estilo translúcido como en el diseño */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 py-6 sm:py-8 gap-3 sm:gap-4 w-full max-w-xs mx-auto">
          <Link
            to="/registro"
            className="w-full py-3.5 sm:py-4 px-6 rounded-xl font-bold text-center text-white bg-white/15 border border-white/40 hover:bg-white/25 transition-colors backdrop-blur-sm"
          >
            Registro
          </Link>
          <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full border-2 border-white/80 text-white font-medium text-base sm:text-lg">
            O
          </div>
          <Link
            to="/login"
            className="w-full py-3.5 sm:py-4 px-6 rounded-xl font-bold text-center text-white bg-white/15 border border-white/40 hover:bg-white/25 transition-colors backdrop-blur-sm"
          >
            Iniciar sesión
          </Link>
        </div>
      </div>

      {/* Logos inferiores */}
      <div className="relative z-20 flex justify-between items-end px-4 py-4 sm:py-6 pb-6 sm:pb-8 gap-4">
        <div className="flex flex-col items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img
              src={logoMedicina}
              alt="Medicina Biorreguladora de Sistemas"
              className="h-14 sm:h-20 w-auto object-contain object-left max-w-[60%] sm:max-w-[75%]"
            />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-7 sm:h-10 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
